// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"eace3d7b","403":"02097f23","551":"a73a44bc","672":"a3d32a49","842":"2398175e"}[chunkId] + ".chunk.js";
};